
import { get, post,deleteRequest } from '../config/$ajax.js'
export const getGoodsFissionRules = (data = {})=> {
  return post('/goodsFission/pageRules', data, {submitType: 'json', isNeedLoading: true })
}
export const goodsFissionAddRule = (data = {})=> {
  return post('/goodsFission/addRule', data, {submitType: 'json', isNeedLoading: true })
}
export const goodsFissionUpdateRule = (data = {})=> {
  return post('/goodsFission/updateRule', data, {submitType: 'json', isNeedLoading: true })
}
export const goodsFissionDeleteRule = (data = {})=> {
  return deleteRequest('/goodsFission/deleteRule', data, {submitType: 'json', isNeedLoading: true })
}
export const getGoodsFissionRuleDetail = (data = {})=> {
  return get('/goodsFission/ruleDetail', data, {submitType: 'json', isNeedLoading: true })
}
export const goodsFissionPreView = (data = {})=> {
  return post('/goodsFission/preView', data, {submitType: 'json', isNeedLoading: true })
}
export const goodsPreViewInfoEdit = (data = {})=> {
  return post('/goodsFission/preViewInfoEdit', data, {submitType: 'json', isNeedLoading: true })
}
export const aiGenerateTitle = (data = {})=> {
  return post('/ai/generateTitle', data, {submitType: 'json', isNeedLoading: true })
}
export const goodsFissionConfig = (data = {})=> {
  return get('/taskCenter/goodsFission/config', data, {submitType: 'json', isNeedLoading: true })
}